const defaultStyle = {
  fontSize: "text-xl",
  fontColor: "text-black",
  textPosition: "text-center",
};

interface OtherDateTitleProps {
  title: string;
  style?: {
    fontSize?: string;
    fontColor?: string;
    textPosition?: string;
  };
}

export const OtherDateTitle: React.FC<OtherDateTitleProps> = ({
  title,
  style = defaultStyle,
}) => {
  return (
    <h2
      className={`${style?.fontSize} ${style?.fontColor} ${style?.textPosition}`}
    >
      {title}
    </h2>
  );
};
